<template>
  <div>
    <el-form-item label="默认值">
       <el-input v-model="data.default"
                placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="是否必填">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-texteditor",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

